export default __webpack_public_path__ + "static/Workout-With-A-View-Hollywood-Sign-009f5f31d5641d4848c4796f9594871b.jpg";